import gql from 'graphql-tag';
import { SellFormShopShippingFragment } from './components/sections/ShippingSection';

export const HydrateSellFormFragment = gql`
  fragment HydrateSellForm on Listing {
    _id
    id
    state
    sku
    year
    make
    countryOfOrigin
    canonicalProductId
    categoryRootUuid
    seedId
    seedType
    publishedAt {
      seconds
    }
    categories {
      _id
      id
      name
      root
      leaf
      rootSlug
    }
    localizedContents {
      locale
      make
      model
      finish
      title
      description
      prop65Warning
      defaultForShop
    }
    handmade
    traits {
      keyId
      valueId
    }
    condition {
      conditionSlug
    }
    hasInventory
    inventory
    upc
    upcDoesNotApply
    taxExempt
    relistable
    video {
      link
    }
    bumpRate {
      rate
    }
    bumpEligible
    images(input: { type: "Product", scope: "photos", transform: "card_square" }) {
      id
      source
      itemId
      version
      itemType
      publicId
      height
      width
      transformation {
        x
        y
        width
        height
        crop
        angle
      }
    }
    shippingProfileId
    allShippingPrices {
      localPickup
      shippingPrices {
        shippingRegionCode
        shippingMethod
        carrierCalculated
        originalRateVatExcluded {
          amount
          currency
        }
      }
    }
    shipmentPackage {
      _id
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      weight {
        value
        unit
      }
    }
    prefersReverbShippingLabel
    sameDayShippingIneligible
    sellerPrice {
      amountCents
      currency
      amount
      display
    }
    sellerCost {
      amountCents
      currency
      amount
      display
    }
    sellerReportedMap {
      amountCents
      currency
      amount
      display
    }
    soldAsIs
    listingType
    overriddenAttributes
    preorderInfo {
      shipDate {
        seconds
      }
      leadTimeDays
    }
    shop {
      _id
      currencySetting
      defaultLocale
      shopSupportedLocaleCodes
      preferredSeller
      hasAccountRep
      listableConditions {
        displayName
        conditionSlug
      }
      offerPolicy {
        autoRejectLowOffers
        lowballPercentage
      }
      returnPolicy {
        newReturnWindowDays
        usedReturnWindowDays
      }
      taxPolicies {
        vatPolicy
      }
      ...SellFormShopShipping
    }
    scheduledPriceDrops {
      active
      dropAt
      newPrice {
        amountCents
        currency
        amount
        display
      }
    }
  },
  ${SellFormShopShippingFragment}
`;
